export const CHATBOT_NAME = 'Flo';
export const CHATBOT_TITLE = 'AI Concierge';
